export default __webpack_public_path__ + "static/media/close-purple-icon.7ba0bd68.svg";